import { useEffect, useState } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import Protected from './pages/Protected';
import VehiculesaPage from './pages/VehiculesaPage';
import ProfilCarPage from './pages/ProfilCarPage';
import ReservationsPagea from './pages/ReservationsPagea';
import VehiculesaLocationPage from './pages/VehiculesaLocationPage';
import RapportPages from './pages/RapportPages';
import RapportLocatairesPages from './pages/RapportLocatairesPages';
import SettingsPages from './pages/SettingsPages';
import Register from './pages/Register';
import UtilisateurPage from './pages/UtilisateurPage';
import ShopPage from './pages/ShopPage';
import ActiclesPage from './pages/ActiclesPage';
import statistiquesShopPage from './pages/StatistiquesShopPage';
import TopPage from './pages/TopPage';
import ProfilPages from './pages/ProfilPages';
import SettinPagerx from './pages/SettinPagerx';
import VerificationOTP from './pages/VerificationOTP';
import MyInvoicesPages from './pages/MyInvoicesPages';
import InfoUserPages from './pages/InfoUserPages';
import EventPages from './pages/EventPages';
import EventDetailPages from './pages/EventDetailPages';
import PublicInvitationResponse from './pages/PublicInvitationResponse';




function App() {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallButton, setShowInstallButton] = useState(false);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstallButton(true); // ✅ On affiche le bouton d’installation
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    console.log(`User response: ${outcome}`);
    setDeferredPrompt(null);
    setShowInstallButton(false);
  };
  return (
    <Router>
      
        {/* ✅ Ton bouton d’installation personnalisé */}
        {showInstallButton && (
          <button
            onClick={handleInstallClick}
            style={{
              position: 'fixed',
              bottom: '20px',
              right: '20px',
              padding: '10px 20px',
              borderRadius: '8px',
              backgroundColor: '#FF6600',
              color: 'white',
              border: 'none',
              fontWeight: 'bold',
              zIndex: 1000,
              cursor: 'pointer'
            }}
          >
            Installer l’application
          </button>
        )}
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/register" element={<Register />} />
        <Route path="/verification-otp" element={<VerificationOTP />} />
        <Route path="/invitation/:id_event/:id" element={<PublicInvitationResponse />} />
      
        <Route path="/dashboard" element={ <Protected Component={HomePage} />} />
        <Route path="/utilisateur" element={ <Protected Component={UtilisateurPage} />} />
        <Route path="/shops" element={ <Protected Component={ShopPage} />} />
        <Route path="/acticles" element={ <Protected Component={ActiclesPage} />} />
        <Route path="/statistiques" element={ <Protected Component={statistiquesShopPage} />} />
        <Route path="/Factures" element={ <Protected Component={VehiculesaPage} />} />
        <Route path="/InfoCar/:id" element={ <Protected Component={ProfilCarPage} />} />
        <Route path="/StatsIa" element={ <Protected Component={ReservationsPagea} />} />
        <Route path="/MyInvoices" element={ <Protected Component={MyInvoicesPages} />} />
        <Route path="/Events" element={ <Protected Component={EventPages} />} />
        <Route path="/showEvent/:id" element={ <Protected Component={EventDetailPages} />} />
        <Route path="/info-user/:tel" element={ <Protected Component={InfoUserPages} />} />
        <Route path="/top10" element={ <Protected Component={TopPage} />} />
        <Route path="/settings" element={ <Protected Component={SettinPagerx} />} />
        <Route path="/profile" element={ <Protected Component={ProfilPages} />} />
     
      </Routes>
    </Router>
  );
}

export default App;

